import { z } from "zod";
import { AddressSchema } from "./companies";

export const CompanyShippingAddressSchema = z.object({
  id: z.string(),
  companyId: z.string(),
  label: z.string(),
  address: AddressSchema,
  salesRepUserId: z.string().nullable(),
  organizationId: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type CompanyShippingAddress = z.infer<
  typeof CompanyShippingAddressSchema
>;

export const CreateCompanyShippingAddressParamsSchema = z.object({
  label: z.string(),
  address: AddressSchema,
  salesRepUserId: z.string().nullable().optional(),
});

export type CreateCompanyShippingAddressParams = z.infer<
  typeof CreateCompanyShippingAddressParamsSchema
>;

export const UpdateCompanyShippingAddressParamsSchema = z.object({
  label: z.string().optional(),
  address: AddressSchema.optional(),
  salesRepUserId: z.string().nullable().optional(),
});

export type UpdateCompanyShippingAddressParams = z.infer<
  typeof UpdateCompanyShippingAddressParamsSchema
>;

// API Response schemas
export const ListCompanyShippingAddressesResponseSchema = z.object({
  shippingAddresses: z.array(CompanyShippingAddressSchema),
});

export type ListCompanyShippingAddressesResponse = z.infer<
  typeof ListCompanyShippingAddressesResponseSchema
>;

export const GetCompanyShippingAddressResponseSchema = z.object({
  shippingAddress: CompanyShippingAddressSchema,
});

export type GetCompanyShippingAddressResponse = z.infer<
  typeof GetCompanyShippingAddressResponseSchema
>;

export const CreateCompanyShippingAddressResponseSchema = z.object({
  shippingAddress: CompanyShippingAddressSchema,
});

export type CreateCompanyShippingAddressResponse = z.infer<
  typeof CreateCompanyShippingAddressResponseSchema
>;

export const UpdateCompanyShippingAddressResponseSchema = z.object({
  shippingAddress: CompanyShippingAddressSchema,
});

export type UpdateCompanyShippingAddressResponse = z.infer<
  typeof UpdateCompanyShippingAddressResponseSchema
>;

export const DeleteCompanyShippingAddressResponseSchema = z.object({
  success: z.boolean(),
});

export type DeleteCompanyShippingAddressResponse = z.infer<
  typeof DeleteCompanyShippingAddressResponseSchema
>;
